import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-103f2871"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "appBox"
};
const _hoisted_2 = {
  class: "appBox__appMain"
};
const _hoisted_3 = {
  class: "appBox__appMain__title"
};
const _hoisted_4 = {
  key: 0,
  class: "appBox__appList"
};
const _hoisted_5 = {
  class: "add-icon__label"
};
import { NDivider, NTree } from 'naive-ui';
import { useI18n } from 'vue-i18n';
import Icon from '@teams/common/components/icon';
import useNavApplication from '../../useNavApplication'; // 是否有添加app的权限

export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      visibleAppList,
      creatAppByLink,
      // gotoCreatApp,
      showAppAdd,
      showAppModule,
      changeApplistOrder,
      appSortable,
      isAllowDrop,
      dragstart,
      dragend,
      renderLabel
    } = useNavApplication();
    const {
      t
    } = useI18n();

    const $tt = (key, ...params) => {
      // @ts-ignore
      return t(`components.navigator.navs.${key}`, ...params);
    };

    return (_ctx, _cache) => {
      return _unref(showAppModule) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(NDivider), {
        class: "appBox__divider"
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString($tt('appTitle')), 1), _unref(visibleAppList).length !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_unref(NTree), {
        "block-line": "",
        draggable: _unref(appSortable),
        "key-field": "appId",
        data: _unref(visibleAppList),
        "render-label": e => _unref(renderLabel)(e, 'vertical'),
        onDrop: _unref(changeApplistOrder),
        onDragend: _unref(dragend),
        onDragstart: _unref(dragstart),
        "allow-drop": _unref(isAllowDrop)
      }, null, 8, ["draggable", "data", "render-label", "onDrop", "onDragend", "onDragstart", "allow-drop"])])) : _createCommentVNode("", true)]), _unref(showAppAdd) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "appAddButton",
        onClick: _cache[0] || (_cache[0] = () => _unref(creatAppByLink)()),
        ref: "addNavRef"
      }, [_createVNode(_unref(Icon), {
        name: "addNav",
        fill: "transparent",
        size: 20
      }), _createElementVNode("span", _hoisted_5, _toDisplayString($tt('addApp')), 1)], 512)) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
    };
  }

});